import { render, staticRenderFns } from "./StatusTransaksi.vue?vue&type=template&id=65f00876&"
import script from "./StatusTransaksi.vue?vue&type=script&lang=js&"
export * from "./StatusTransaksi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports